import classNames from 'classnames';

import { useLogoStyles } from './Logo.styles';

export function HeaderLogo({ size = 'md', className, children, ...rest }) {
  const { styles } = useLogoStyles();
  return (
    <div
      className={classNames(
        'QuickOnlineLogo',
        styles.logo,
        `size-${size}`,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function SmallLogo({ size = 'md', className, children, ...rest }) {
  const { styles } = useLogoStyles();
  return (
    <div
      className={classNames(
        'QuickOnlineLogoQ',
        styles.logoQ,
        `size-${size}`,
        className
      )}
      {...rest}
    />
  );
}
